module.exports = __webpack_public_path__ + "img/theme8.8cbabe89.png";